import React from 'react';
import styles from './services.module.css';
import Title from "../components/global/title/Title";
import TimelineList from "../components/global/timelineList/TimelineList";
import { GraduationCap, Laptop, RefreshCcw, Search, Shield, GitPullRequest, Cloud } from "lucide-react";

const Services = ({ isInView, name }) => {
    const dataServices = [
        {
            icon: Laptop,
            title: "Site web sur mesure",
            desc: "Vitrine, e‑commerce ou applicatif métier personnalisé pour votre structure : je conçois une solution à votre image."
        },
        {
            icon: RefreshCcw,
            title: "Refonte & Modernisation",
            desc: "Donnez un coup de jeune à votre site avec un design moderne, une navigation intuitive et une expérience utilisateur optimisée."
        },
        {
            icon: Search,
            title: "SEO & Performance",
            desc: "Optimisation du référencement naturel et des temps de chargement (Core Web Vitals inclus)."
        },
        {
            icon: Shield,
            title: "Maintenance & Sécurité",
            desc: "Protection proactive, et bénéficiez d'une maintenance régulière."
        },
        {
            icon: GitPullRequest,
            title: "Architecture & DevOps",
            desc: "Conception d'architectures web scalables et gestion de l'infrastructure pour tout type de trafic, du petit au gros événement."
        },
        {
            icon: GraduationCap,
            title: "Formation et autonomie",
            desc: "Je forme vos équipes ou relais internes pour que vous soyez totalement autonome sur la gestion de votre site.."
        },
        {
            icon: Cloud,
            title: "Hébergement & Mise en ligne",
            desc: "Un site sans hébergement, c’est comme une voiture sans essence. Je m’occupe de tout, de la mise en ligne à l’hébergement."
        }

    ];

    return (
        <section id="Services" className={styles.servicesContainer}>
            <Title number={2}>{name}</Title>
            <TimelineList 
                items={dataServices} 
                showTimeline={true} 
                className="services" 
            />
        </section>
    );
};

export default Services;